import styled from "styled-components";
import { ReactElement, useEffect, useState } from "react";
import { ChallengeScheme, ErrorScheme, Feed } from "client-v2";
import ChallengeCell from "../../cell/ChallengeCell";
import { Button, ColorV2 } from "@adoptaunabuelo/react-components";
import { ChevronLeft, ChevronRight } from "lucide-react";
import ChallengeLoadingAnimation from "../../../assets/animations/challenge_loading.json";
import { Player } from "@lottiefiles/react-lottie-player";
import { useSelector } from "react-redux";
import { State } from "../../../redux";
import RightSectionContainer from "../../container/RightSectionContainer";
import media from "styled-media-query";

const ChallengeContainer = styled.div`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	scrollbar-width: none;
	-ms-overflow-style: none;
	&::-webkit-scrollbar {
		display: none;
	}
	${media.lessThan("medium")`
		flex-direction: row;
		overflow: scroll;
		margin: 0px -24px;
		padding: 0px 24px;
		gap: 12px;
    `}
`;
const Row = styled.div`
	display: flex;
	flex-direction: row;
	margin-top: 8px;
	justify-content: flex-end;
	align-items: center;
`;
const ButtonContainer = styled.div`
	display: flex;
	gap: 8px;
`;

const SuccessRight = (props: SuccessRightProps) => {
	const isMobile: boolean = useSelector(
		(state: State) => state.screen.isMobile
	);
	const [loading, setLoading] = useState(false);
	const [challenges, setChallenges] = useState<ChallengeScheme[]>([]);
	const [index, setIndex] = useState(0);
	const [totalAmount, setTotalAmount] = useState(0);
	const [animation, setAnimation] = useState<string>("fadeOut");

	useEffect(() => {
		getChallenges();
		if (isMobile || !props.animationTime) setAnimation("fadeIn");
		else
			setTimeout(() => {
				setAnimation("fadeIn");
			}, props.animationTime * 1000);
	}, []);

	const getChallenges = async () => {
		setLoading(true);
		Feed.getForLetter({
			version: 1,
		})
			.then((result) => {
				const tempChallenge: ChallengeScheme[] = [];
				result.data.map((i) =>
					i.rendedData.map((j) => tempChallenge.push(j.challenge))
				);
				setChallenges(
					props.initialCell
						? [
								{
									type: "initial-cell",
								} as any,
								...tempChallenge,
						  ]
						: tempChallenge
				);
				setTotalAmount(
					result.pagination?.count ? result.pagination?.count : 0
				);
				setLoading(false);
			})
			.catch((e: ErrorScheme) => {
				setLoading(false);
			});
	};

	return (
		<RightSectionContainer
			style={
				isMobile
					? {
							margin: "0px -24px",
							padding: "32px 24px 16px",
							width: "unset",
							marginTop: 32,
							backgroundColor: ColorV2.surface.background,
					  }
					: {
							marginLeft: 48,
							marginTop: 48,
							width: animation === "fadeIn" ? 388 : 0,
							opacity: animation === "fadeIn" ? 1 : 0,
							transition:
								"width 0.5s ease-in-out, opacity 0.5s ease-in-out 0.3s",
					  }
			}
			dataContainerStyle={{ justifyContent: "unset" }}
			childrenProps={{
				style: { marginBottom: 0 },
			}}
			title="Más iniciativas de nuestra fundación"
			subtitle="Queremos hacer felices a las personas mayores. Tu aportación, por pequeña que sea, tiene un gran impacto."
		>
			<ChallengeContainer>
				{loading || challenges.length <= 0 ? (
					<Player
						style={{
							width: isMobile ? "100%" : 388,
							height: 315,
						}}
						loop={true}
						autoplay={true}
						src={ChallengeLoadingAnimation}
					/>
				) : isMobile ? (
					challenges.map((item, index) => {
						if ((item.type as any) === "initial-cell") {
							return props.initialCell;
						} else {
							return (
								<ChallengeCell
									key={`challenge-${index}`}
									challenge={item}
									amount={item.amount}
								/>
							);
						}
					})
				) : (challenges[index].type as any) === "initial-cell" ? (
					props.initialCell
				) : (
					<ChallengeCell
						challenge={challenges[index]}
						amount={challenges[index].amount}
					/>
				)}
			</ChallengeContainer>
			{!isMobile && (
				<Row>
					<ButtonContainer>
						<Button
							style={{
								borderRadius: 100,
								height: 40,
								width: 40,
								border: `1px solid ${ColorV2.border.neutralSoft}`,
							}}
							design="image"
							icon={<ChevronLeft />}
							disabled={index <= 0 || loading}
							onClick={() => {
								if (index > 0) setIndex(index - 1);
							}}
						/>
						<Button
							style={{
								borderRadius: 100,
								height: 40,
								width: 40,
								border: `1px solid ${ColorV2.border.neutralSoft}`,
							}}
							design="image"
							icon={<ChevronRight />}
							disabled={index >= totalAmount - 1 || loading}
							onClick={() => {
								if (index < totalAmount - 1)
									setIndex(index + 1);
							}}
						/>
					</ButtonContainer>
				</Row>
			)}
		</RightSectionContainer>
	);
};
export default SuccessRight;
export interface SuccessRightProps {
	animationTime?: number;
	initialCell?: ReactElement;
}
